/*
 * Get-address-data.ts
 * Description: Includes the declaration of a function
 * for getting the complete information about a single address
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Getting the complete information about a single address
 *
 * @param {Number} id - id of an address
 * @return {Object} Promise - when the request is resolved
 */
export function getAddressData(id: number) {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        const jwt = localStorage.getItem('jwt');
        // Using Axios to send the request
        Axios({
            url: APIURL + 'addresses/' + id,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data.data.attributes);
        }).catch((error) => {
            reject();
        });
    });
}
